import { pxToRem } from '../../utils';
var treeTitleStyles = {
    root: function (_a) {
        var variables = _a.variables;
        return ({
            padding: pxToRem(1) + " 0",
            cursor: 'pointer',
            color: variables.defaultColor,
        });
    },
};
export default treeTitleStyles;
